const button = document.querySelector('.gr-product-description__button');
    const text = document.querySelector('.gr-product-description__text');
    const span = button.querySelector('span');
    const icon = button.querySelector('i');

    function checkTextHeight() {
        if (text.scrollHeight > 72) {
            button.style.display = 'flex';
        } else {
            button.style.display = 'none';
        }
    }
    
    window.addEventListener('load', checkTextHeight);

    button.addEventListener('click', function() {
        text.classList.toggle('gr-product-description__text--visible');

        if (text.classList.contains('gr-product-description__text--visible')) {
            span.textContent = 'Read less';
        } else {
            span.textContent = 'Read more';
        }
});